/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для пользовательских данных в кабинете.
   */
  app.UserDataNewView = app.View.extend({
    el: '#user-data',
    jsonUserContacts: '#json-user-contacts',
    template: app.helpers.TemplateHelper.getTemplate('#user-contact-rows-view-template'),
    userPhoneTemplate: app.helpers.TemplateHelper.getTemplate('#user-phone-view-template'),
    userNameTemplate: app.helpers.TemplateHelper.getTemplate('#user-name-view-template'),
    userPhotoTemplate: app.helpers.TemplateHelper.getTemplate('#user-photo-template'),
    selectors: {
      plainEmail: '#plain_email',
      plainPhone: '#plain_phone',
      plainName: '.user-prof__greeting .h5',
      additionalPhones: '#additional-phone-raws',
      userPhoto: '.b-avatar',
    },
    events: {
      'click .user-toggle': 'showFormUserData',
    },

    /**
     * @param boolean Успешно сохранены данные пользователя
     */
    successUserData: false,

    /**
     * @param boolean Успешно обновлены телефоны
     */
    successPhoneList: false,

    run: function () {
      this.collection = new app.UserContacts();
      this.collection.reset(app.helpers.TemplateHelper.getJson($(this.jsonUserContacts)));
      // Форма для редактирования данных пользователя только на русской версии сайта
      if (app.locale === app.LOCALES.ru) {
        this.childViews.userDataForm = new app.UserDataNewFormView({
          collection: this.collection,
          user: this.user,
        });
        this.listenTo(this.childViews.userDataForm, 'success-user-data-form', this.render);
        this.listenTo(this.childViews.userDataForm, 'cancel-user-data-form', this.toggle);
        this.listenTo(this.user, 'change:photo_url', function () {
          this.$(this.selectors.userPhoto).html(this.userPhotoTemplate({model: this.user}));
        });
      }
    },

    render: function () {
      this.$(this.selectors.plainPhone).html(this.userPhoneTemplate({model: this.user}));
      this.$(this.selectors.additionalPhones).html(this.template({models: this.collection.models}));
      this.$(this.selectors.plainName).text(this.userNameTemplate({model: this.user}));
      this.$(this.selectors.plainEmail).text(this.user.get('email'));
      this.toggle();
    },

    /**
     * Показывает форму изменения личных данных пользователя
     * @param {Object} e Объект события
     */
    showFormUserData: function (e) {
      $(e.currentTarget).closest('.b-card').children()
        .stop(true, true)
        .animate({
          height: 'toggle',
          opacity: 'toggle',
        }, 500);
    },
  });
})(jQuery);

}.call(window));